import {useTranslation} from 'react-i18next';
import {DownOutlined} from '@ant-design/icons';
import type {MenuProps} from 'antd';
import {Button, Dropdown} from 'antd';


interface Props {
    small?: boolean
    block?: boolean
}

export const SelectLanguage = ({small, block}:Props) => {

    const {t, i18n} = useTranslation()

    let current
    switch (i18n.language) {
        case 'en':
            current = `${t('English')}`;
            break;
        case 'es':
            current = `${t('Spanish')}`;
            break;
        case 'vn':
            current = `${t('Vietnamese')}`;
            break;
    }

    const items: MenuProps['items'] = [
        {
            key: 'en',
            label: t('English'),
            onClick: () => i18n.changeLanguage('en'),
        },
        {
            key: 'es',
            label: t('Spanish'),
            onClick: () => i18n.changeLanguage('es'),
        },
        {
            key: 'vn',
            label: t('Vietnamese'),
            onClick: () => i18n.changeLanguage('vn'),
        },
        // {
        //     key: 'kz',
        //     label: t('Kazakh'),
        //     onClick: () => i18n.changeLanguage('kz'),
        // },
    ]

    return (
        <Dropdown menu={{items}}>
            <Button block={block} size={small ? 'small' : 'large'}>{current}<DownOutlined/></Button>
        </Dropdown>
    )
}